import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { User } from 'src/app/shared/models/security/user';
import { FacadeService } from '../services/facade.service';
import { Authority } from '../../shared/models/security/authority';

@Injectable({
	providedIn: 'root'
})
export class AuthorityGuard {
	user: User;
	constructor(private facade: FacadeService, private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		let roles = route.data.roles as Array<Authority>; //Récupération des paramètres transmis par la route
		this.user = this.facade.dataStorageService.getUser();

		//si le role de l'utilisateur est dans la liste transmise, autorise l'accès sinon le redirige vers le dashboard
		if (roles.some((authority) => authority === this.user.role.id)) {
			return true;
		} else {
			this.router.navigate(['dashboard']);
			return false;
		}
	}
}
